import type React from 'react';

import { useTranslation } from 'react-i18next';

import { useAppState } from '../../../../AppStateProvider';
import { useIsInternalDomain } from '../../../../hooks/useIsInternalDomain';
import { getFaviconUrl } from '../../../../services/favicon';
import {
  StyledCompanyLogo,
  StyledCorrespondenceWithText,
  StyledEmailDomain,
  StyledEmailDomainContainer,
  StyledEmailSubject,
  StyledMeetingInternalText,
  StyledMultipleDomainsButtonText,
} from '../styles';

interface Props {
  selectedDomain?: string;
  selectedDomainName?: string;
  domainsAmount?: number;
}

export const MultipleDomainsEmail: React.FC<Props> = ({ selectedDomain, selectedDomainName, domainsAmount }) => {
  const { collectedEmail, collectedDomains } = useAppState();
  const { t } = useTranslation();

  const isInternalEmail = useIsInternalDomain(collectedDomains ?? []);

  const subject = collectedEmail.subject || t('email.subject.new');

  return (
    <>
      <StyledEmailSubject>{subject}</StyledEmailSubject>
      {selectedDomain && domainsAmount === 1 ? (
        <>
          <StyledEmailDomainContainer>
            <StyledMultipleDomainsButtonText isSingleDomain>
              {t('email.correspondence_with')}
            </StyledMultipleDomainsButtonText>
            <StyledEmailDomain>
              <StyledCompanyLogo isSmall data-automation="MultipleDomainsCompanyLogo">
                <img src={getFaviconUrl(selectedDomain, 10)} width="10px" height="10px" alt={selectedDomain} />
              </StyledCompanyLogo>
              <StyledCorrespondenceWithText>{selectedDomainName || selectedDomain}</StyledCorrespondenceWithText>
            </StyledEmailDomain>
          </StyledEmailDomainContainer>
          {isInternalEmail ? <StyledMeetingInternalText>{t('email.internal_email')}</StyledMeetingInternalText> : null}
        </>
      ) : null}
    </>
  );
};
